<template>
  <div class="c-footer px">
    <div class="footer-content">
      <a-tooltip
        overlayClassName="footer-tooltip"
        placement="top"
        :mouseLeaveDelay="0.3"
        arrowPointAtCenter
      >
        <template slot="title">
          <c-video
            class="tutorial-item"
            :key="'CYBERBOARD_TUTORIAL_' + isCN"
            :src="
              isCN ? oss.tutorial_cyberboard_cn : oss.tutorial_cyberboard_en
            "
            target="_blank"
          >
            CYBERBOARD
          </c-video>
          <c-video
            class="tutorial-item"
            :key="'HATSU_TUTORIAL_' + isCN"
            :src="isCN ? oss.tutorial_hatsu_cn : oss.tutorial_hatsu_en"
            target="_blank"
          >
            HATSU
          </c-video>
        </template>
        <div class="tutorial">
          <i class="next iconfont iconvideo" />
          {{ $t("tutorial") }}
        </div>
      </a-tooltip>
      <a-tooltip
        v-if="isCN"
        overlayClassName="footer-tooltip large-radius"
        placement="top"
        :mouseLeaveDelay="0.3"
        arrowPointAtCenter
      >
        <template slot="title">
          <div class="footer-qq">
            <img :src="images.qrcode_qq" alt="qq" />
          </div>
        </template>
        <div class="qq">
          <i class="next iconfont iconqq" />
          {{ $t("joinQQ") }}
        </div>
      </a-tooltip>
      <a
        v-else
        class="discord"
        href="https://discord.gg/Xre4H4c"
        target="_blank"
      >
        <i class="next iconfont icondiscord" />
        {{ $t("joinDiscord") }}
      </a>
      <a-tooltip
        overlayClassName="footer-tooltip"
        placement="top"
        :mouseLeaveDelay="0.3"
        arrowPointAtCenter
      >
        <template slot="title">
          <div class="tutorial-item" @click="setLanguage('cn')">中文</div>
          <div class="tutorial-item" @click="setLanguage('en')">English</div>
          <div class="tutorial-item" @click="setLanguage('ja')">日本語</div>
        </template>
        <div class="language">
          <img v-if="language === 'cn'" :src="images.lang_cn" alt="language" />
          <img
            v-else-if="language === 'en'"
            :src="images.lang_en"
            alt="language"
          />
          <img
            v-else-if="language === 'ja'"
            :src="images.lang_ja"
            alt="language"
          />
          {{ $t("language") }}
        </div>
      </a-tooltip>
      <a class="copyright" href="https://beian.miit.gov.cn/" target="_blank">
        Copyright © {{ year }} Angry Miao<br />粤ICP备19155896号 {{ isCN }}
      </a>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "CFooter",
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
  computed: {
    ...mapState("app", {
      language: "language",
      isCN: "isCN",
    }),
    ...mapState("assets", {
      images: "images",
      oss: "oss",
    }),
  },
  methods: {
    onItemClick(path) {
      this.$router.push(path);
    },
    setLanguage(lang) {
      this.$store.dispatch("app/setLanguage", lang);
    },
  },
};
</script>
<style lang="scss" scoped>
.c-footer.px {
  width: 100%;
  height: $footer-height;

  .footer-content {
    @include flex-center;
    width: 100%;
    height: $footer-height;
    background: #2f2f2f;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 1000;
    justify-content: space-between;
    padding: 0 calc((100vw - 1200px) / 2);

    .tutorial,
    .qq,
    .discord {
      @include flex-center;
      cursor: pointer;
      color: #ffffff;
      font-size: 12px;

      i {
        font-size: 20px;
        margin-right: 5px;
      }

      &:hover {
        color: $primary-color;
      }
    }

    .language {
      width: auto;
      font-size: 14px;
      color: #b5b5b5;
      cursor: pointer;

      img {
        height: 26px;
        margin-right: 5px;
      }
    }

    .copyright {
      width: 200px;
      font-size: 10px;
      color: #999999;
      text-align: center;
      margin-right: 20px;
      white-space: nowrap;
      cursor: pointer;
    }
  }
}
</style>

<style lang="scss">
.footer-tooltip {
  max-width: none;
  .ant-tooltip-arrow::before {
    background: #444444;
  }

  .ant-tooltip-inner {
    background-color: #444444;
    padding: 0;
    overflow: hidden;
  }

  &.large-radius .ant-tooltip-inner {
    border-radius: 20px;
  }

  .tutorial-item {
    text-align: center;
    padding: 6px 8px;
    cursor: pointer;
    border-bottom: 1px solid #333333;

    &:hover {
      background-color: $primary-color;
    }

    &:last-child {
      border: 0;
    }
  }

  .footer-qq {
    padding: 5px;
    background: transparent;

    img {
      width: 200px;
      height: 200px;
    }
  }
}
</style>
